<script lang="ts">
  import { afterUpdate } from "svelte";

  export let xmlContent: string;

  function parseExplanations() {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = xmlContent;
    const explains = tempDiv.querySelectorAll("Explain");
    explains.forEach((explain) => {
      const term = explain.textContent;
      const explanation =
        explain.querySelector("Explanation")?.textContent || "";
      const termSpan = document.createElement("span");
      termSpan.textContent = term.replace(
        explain.querySelector("Explanation").textContent,
        ""
      );
      termSpan.classList.add("tooltip-term");
      termSpan.dataset.explanation = explanation;
      explain.replaceWith(termSpan);
    });
    return tempDiv.innerHTML;
  }

  function setupTooltips() {
    document.querySelectorAll(".tooltip-term").forEach((tooltip) => {
      const tooltipContent = document.createElement("div");
      tooltipContent.classList.add("tooltip-content");
      tooltipContent.textContent = tooltip.dataset.explanation;
      document.body.appendChild(tooltipContent);
      // tooltipContent.className = "tooltip"

      tooltip.addEventListener("mouseenter", () => {
        const termRect = tooltip.getBoundingClientRect();
        const tooltipRect = tooltipContent.getBoundingClientRect();
        let left = termRect.right + 8;
        let top = termRect.top - 10;

        if (left + tooltipRect.width > window.innerWidth - 20) {
          left = termRect.left - tooltipRect.width - 8;
        }
        if (top + tooltipRect.height > window.innerHeight - 20) {
          top = window.innerHeight - tooltipRect.height - 20;
        }
        if (top < 20) top = 20;
        if (left < 20) left = 20;

        tooltipContent.style.left = `${left}px`;
        tooltipContent.style.top = `${top}px`;
        tooltipContent.style.visibility = "visible";
        tooltipContent.style.opacity = "1";
      });

      tooltip.addEventListener("mouseleave", () => {
        tooltipContent.style.visibility = "hidden";
        tooltipContent.style.opacity = "0";
      });
    });
  }

  afterUpdate(() => {
    setupTooltips()

    document.querySelectorAll("a").forEach(node => 
      node.setAttribute("target", "_blank")
    )
  });

  $: content = parseExplanations();
</script>

<div class="text-lg text-black container">
  {@html content}
</div>

<style>
  :global(.tooltip-term) {
    text-decoration: underline dotted;
    cursor: help;
    position: relative;
    display: inline-block;
    color: #2563eb;
  }

  :global(.tooltip-content) {
    position: fixed;
    background: white;
    padding: 16px 20px;
    border-radius: 12px;
    box-shadow:
      0 4px 6px rgba(0, 0, 0, 0.1),
      0 0 1px rgba(0, 0, 0, 0.2);
    font-size: 16px;
    line-height: 1.5;
    max-width: 300px;
    z-index: 2147483647;
    color: #1f2937;
    visibility: hidden;
    opacity: 0;
    transition:
      opacity 0.2s,
      visibility 0.2s;
    pointer-events: none;
  }

  :global(.container p) {
    margin-top: 10px;
  }

  :global(.container a) {
    text-decoration: underline;
  }

  :global(.container h3) {
    margin-top: 22px;
    margin-bottom: 5px;
    color: black;
    font-size: 22px;
  }

  :global(.container ul, .container ol) {
    list-style-type: disc !important;
    padding-left: 40px;
    margin-top: 7px;
    color: black;
  }
</style>
